import {
  COPY_ITEM_AND_CREATE_ITEM_SHARE_START,
  COPY_ITEM_AND_CREATE_ITEM_SHARE_SUCCESS,
  COPY_ITEM_AND_CREATE_ITEM_SHARE_FAILED,
  DELETE_ITEM_SHARE_START,
  DELETE_ITEM_SHARE_SUCCESS,
  DELETE_ITEM_SHARE_FAILED,
  UPDATE_ITEM_SHARE_ACTIVE_STATE_START,
  UPDATE_ITEM_SHARE_ACTIVE_STATE_SUCCESS,
  UPDATE_ITEM_SHARE_ACTIVE_STATE_FAILED,
} from 'chameleon-src/actionTypes';

const initialState = {
  itemShares: [],
  isFetching: false,
  errorMessage: '',
  isFetched: false,
};

const itemShares = (state = initialState, action) => {
  const { type, payload } = action;
  const { errorMessage } = payload || {};

  switch (type) {
    case COPY_ITEM_AND_CREATE_ITEM_SHARE_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
        isFetched: false,
      };
    case COPY_ITEM_AND_CREATE_ITEM_SHARE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        itemShares: [payload],
        isFetched: true,
      };
    case COPY_ITEM_AND_CREATE_ITEM_SHARE_FAILED:
      return {
        ...state,
        isFetching: false,
        errorMessage,
        isFetched: false,
      };
    case DELETE_ITEM_SHARE_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      };
    case DELETE_ITEM_SHARE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        itemShares: payload,
        isFetched: true,
      };
    case DELETE_ITEM_SHARE_FAILED:
      return {
        ...state,
        isFetching: false,
        errorMessage,
        isFetched: false,
      };
    case UPDATE_ITEM_SHARE_ACTIVE_STATE_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      };
    case UPDATE_ITEM_SHARE_ACTIVE_STATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        itemShares: payload,
      };
    case UPDATE_ITEM_SHARE_ACTIVE_STATE_FAILED:
      return {
        ...state,
        isFetching: false,
        errorMessage,
        isFetched: false,
      };
    default:
      return state;
  }
};

export default itemShares;
